import gql from 'graphql-tag';




const GET_ALL = gql `
    query all($perPage: Int!,$page: Int, $where: HakAksesWhereWhereConditions, $orderBy: [HakAksesOrderByOrderByClause!]){
        hakAkses(first: $perPage, page: $page, where: $where, orderBy: $orderBy){
            data{
                id
                uuid,
                tipe_akses,
                name,
                url,
                icon,
                show,
                is_group,
                parentakses_id
                submenu{
                  id
                  uuid,
                  tipe_akses,
                  name,
                  url,
                  icon,
                  show,
                  is_group,
                  parentakses_id,
                  order
                }
                order
            }
            paginatorInfo {
                count
                total
                hasMorePages
                currentPage
                lastPage
                perPage
            }
        }
    }
`;

const FIND = gql `
  query find($uuid: String!){
    hakAksesByUuid(uuid: $uuid){
      id
      uuid
      name
      tipe_akses
      url
      icon
      parentakses_id
      parent{
        id
        uuid
        name
      }
      child{
        id
        uuid
        name
        tipe_akses
        url
        icon
        parentakses_id
        parent{
          id
          uuid
          name
        }
      }
    }
  }
`

const CREATE = gql `
  mutation($input:HakAksesCreateInput!){
    hakAksesCreate(input:$input){
      id,
      tipe_akses,
      url,
      name,
      icon,
      tag,
      uuid
    }
  }
`;

const UPDATE = gql `
  mutation($id: ID!, $input:HakAksesUpdateInput!){
    hakAksesUpdate(id: $id,input:$input){
      uuid
      name
      tipe_akses
      url
      icon
      parentakses_id
      parent{
        id
        uuid
        name
      }
    }
  }
`;

export {
  GET_ALL,
  CREATE,
  FIND,
  UPDATE
}
